import type { PaymentItemDetails, UpdatePaymentRequest } from '../../../generated-types';
import { FormattedFuturePayment } from '../../../utils/mapper/futurepaymentsUtil';

export default (
    futurePayment: FormattedFuturePayment,
    futurePaymentDetails?: PaymentItemDetails,
): UpdatePaymentRequest => {
    return {
        paymentType: futurePayment.paymentType,
        amount: Math.abs(futurePayment.amount ?? 0),
        currency: 'NOK',
        fromAccountNumber: futurePayment.fromAccount.accountNumber,
        paymentDate: futurePayment.date.toISOString(),
        toAccount: futurePayment.toAccount.accountNumber!,
        text: futurePayment.description,
        ownText: futurePaymentDetails?.ownText,
        kid: futurePaymentDetails?.kid,
        efakturaId: futurePaymentDetails?.eFakturaId,
    };
};
